import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageHeader.module.scss';

/* ────────────────────────────────────────────────────────────
 * PageHeader — elevated header card for every page.
 *
 *   <PageHeader
 *     title="My Attendance"
 *     subtitle="Your check-ins, sessions and totals."
 *     actions={<DownloadIconButton onClick={...} />}
 *   >
 *     <Select ... />
 *     <Select ... />
 *   </PageHeader>
 *
 * Layout: title block on the left, an inline filter row in the
 * middle (children), and an actions cluster on the right. Stacks
 * vertically below `$bp-md`.
 * ──────────────────────────────────────────────────────────── */

const PageHeader = ({ title, subtitle, actions, children, className,icon=null }) => {
  const headerClass = [styles.header, className || ''].filter(Boolean).join(' ');
  const hasToolbar = Boolean(children) || Boolean(actions);

  return (
    <header className={headerClass}>
      <div className='d-flex'>
        <div>
          {icon}
        </div>
       <div className={styles.heading}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      </div>

      {hasToolbar && (
        <div className={styles.toolbar}>
          {children && <div className={styles.filters}>{children}</div>}
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      )}
    </header>
  );
};

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

PageHeader.defaultProps = {
  subtitle: null,
  actions: null,
  children: null,
  className: '',
};

export default PageHeader;
